'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createQuantityUpgradesPayload = undefined;

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuantityUpgradesPayload = exports.createQuantityUpgradesPayload = function createQuantityUpgradesPayload(itemConfigurations) {
  return itemConfigurations.map(function (itemConfiguration) {
    var quantityMultiplier = _ImmutableMerchandiseIdMap2.default[itemConfiguration.merchandiseId].quantityMultiplier;
    var calculatedQuantity = Math.ceil(itemConfiguration.quantity / quantityMultiplier);

    itemConfiguration.quantity = calculatedQuantity;

    return itemConfiguration;
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/utilities/createQuantityUpgradesPayload.js
// module id = 588
// module chunks = 3 4 5